"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPostsResponseSchema = exports.MentorshipPairSchema = exports.MentorshipStatusSchema = exports.UserBadgeSchema = exports.BadgeTypeSchema = exports.CommentVerificationResultSchema = exports.CommentVerificationSourceSchema = exports.CreatePostRequestSchema = exports.CommunityPostSchema = exports.TREUBOT_USER_ID = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
// TreuBot system user ID
exports.TREUBOT_USER_ID = '00000000-0000-0000-0000-000000000001';
// Community Post
exports.CommunityPostSchema = zod_1.z.object({
    id: common_1.UUIDSchema,
    userId: common_1.UUIDSchema,
    author: zod_1.z.object({
        id: common_1.UUIDSchema,
        displayName: zod_1.z.string(),
        communityLevel: zod_1.z.string(),
        reputationScore: zod_1.z.number(),
        isBot: zod_1.z.boolean().optional(),
    }),
    content: zod_1.z.string().min(10).max(2000),
    upvotes: zod_1.z.number().min(0),
    downvotes: zod_1.z.number().min(0),
    commentCount: zod_1.z.number().min(0),
    userVote: zod_1.z.enum(['upvote', 'downvote']).nullable().optional(),
    createdAt: common_1.DateSchema,
    updatedAt: common_1.DateSchema,
});
// Create Post Request
exports.CreatePostRequestSchema = zod_1.z.object({
    content: zod_1.z.string().min(10).max(2000),
});
// Verification result attached to TreuBot comments
exports.CommentVerificationSourceSchema = zod_1.z.object({
    url: zod_1.z.string(),
    title: zod_1.z.string(),
    credibilityScore: zod_1.z.number().optional(),
    sourceType: zod_1.z.string().optional(),
});
exports.CommentVerificationResultSchema = zod_1.z.object({
    verdict: zod_1.z.string(),
    confidence: zod_1.z.number(),
    reasoning: zod_1.z.string(),
    sources: zod_1.z.array(exports.CommentVerificationSourceSchema).optional(),
});
// Badge Types
exports.BadgeTypeSchema = zod_1.z.enum([
    'first_questioner',
    'source_detective',
    'nuance_navigator',
    'truth_seeker',
    'community_helper',
    'mentor',
    'wisdom_guide',
    'fact_champion'
]);
// User Badge
exports.UserBadgeSchema = zod_1.z.object({
    id: common_1.UUIDSchema,
    userId: common_1.UUIDSchema,
    badgeType: exports.BadgeTypeSchema,
    earnedAt: common_1.DateSchema,
    badgeData: zod_1.z.record(zod_1.z.any()).optional(),
});
// Mentorship Status
exports.MentorshipStatusSchema = zod_1.z.enum(['active', 'completed', 'paused', 'cancelled']);
// Mentorship Pair
exports.MentorshipPairSchema = zod_1.z.object({
    id: common_1.UUIDSchema,
    mentorId: common_1.UUIDSchema,
    menteeId: common_1.UUIDSchema,
    mentor: zod_1.z.object({
        id: common_1.UUIDSchema,
        displayName: zod_1.z.string(),
        communityLevel: zod_1.z.string(),
        reputationScore: zod_1.z.number(),
    }),
    mentee: zod_1.z.object({
        id: common_1.UUIDSchema,
        displayName: zod_1.z.string(),
        communityLevel: zod_1.z.string(),
    }),
    status: exports.MentorshipStatusSchema,
    createdAt: common_1.DateSchema,
    updatedAt: common_1.DateSchema,
});
// Community Posts Response
exports.CommunityPostsResponseSchema = zod_1.z.object({
    posts: zod_1.z.array(exports.CommunityPostSchema),
    pagination: common_1.PaginationSchema,
});
//# sourceMappingURL=community.js.map